import { useEffect, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { useSelector, useDispatch } from 'react-redux';
import FilterAltIcon from '@mui/icons-material/FilterAlt';

import Button from 'core/buttons/Button';
import MoreActions from 'core/lab/MoreActions';
import ReloadButton from 'core/buttons/ReloadButton';
import TableGridFilter from 'core/table/TableGridFilter';
import ColumnVisibility from 'core/table/ColumnVisibility';
import TableActionsContainer from 'core/table/TableActionsContainer';

import Sheet from 'utils/Sheet';
import app from 'app/config/app';
import FilterType from 'app/config/FilterType';
import useQueryParams from 'hooks/useQueryParams';
import { getPartnerApiLogs } from 'app/features/partner-api-logs/partnerApiLogSaga';
import { setParam, deleteFilterParams } from 'app/features/partner-api-logs/partnerApiLogSlice';

const availableFilters = [
  {
    label: 'Request ID',
    value: 'RequestId',
    type: FilterType.input,
  },
  {
    label: 'Partner Code',
    value: 'PartnerCode',
    type: FilterType.input,
  },
];

export default function PartnerApiLogsActions({ table }) {
  const dispatch = useDispatch();

  const [showFilter, setShowFilter] = useState(false);

  const logsState = useSelector((state) => state.partnerApiLogs.index);

  const [queryParams, updateQueryParams] = useQueryParams(app.ignoreFilterKeys);

  const { params: appliedFilters } = logsState;

  const handleOnFilter = useCallback(
    (data) => {
      dispatch(setParam({ ...data, page_number: 1 }));
    },
    [dispatch],
  );

  const handleOnReset = useCallback(() => {
    dispatch(deleteFilterParams(availableFilters.map((filter) => filter.value)));
  }, [dispatch]);

  useEffect(() => {
    updateQueryParams(appliedFilters);
  }, [JSON.stringify(appliedFilters)]);

  useEffect(() => {
    dispatch(setParam(queryParams));
  }, [JSON.stringify(queryParams)]);

  return (
    <>
      <Box>
        <TableGridFilter
          showFilter={showFilter}
          appliedFilters={appliedFilters}
          availableFilters={availableFilters}
          onFilter={handleOnFilter}
          onReset={handleOnReset}
        />
      </Box>
      <TableActionsContainer>
        <Box />
        <Box display="flex" gap={1}>
          <Button
            variant="outlined"
            endIcon={<FilterAltIcon />}
            onClick={() => setShowFilter(!showFilter)}
            uppercase
          >
            Filter
          </Button>
          {table && <ColumnVisibility table={table} />}
          <ReloadButton
            onClick={() => {
              dispatch(
                getPartnerApiLogs({
                  ...appliedFilters,
                  page_number: 1,
                }),
              );
            }}
          />
          <MoreActions
            onExportToCsv={() => Sheet.exportReactTableSelectedRowsToCsv(table, 'partner_api_logs_')}
            onExportToExcel={() =>
              Sheet.exportReactTableSelectedRowsToExcel(table, 'partner_api_logs_')
            }
          />
        </Box>
      </TableActionsContainer>
    </>
  );
}

PartnerApiLogsActions.propTypes = {
  table: PropTypes.object,
};
